import { gql } from "urql";
export const QueryDataWithAIMutation = gql `
    mutation QueryDataWithAI(
        $naturalLanguageQuery: String!
        $chatSeriesId: String
    ) {
        ai {
            queryData(
                naturalLanguageQuery: $naturalLanguageQuery
                chatSeriesId: $chatSeriesId
            ) {
                aiQueryRequestId
                chatSeriesId
                notes
                rows
                createdAt
            }
        }
    }
`;
export const RerunAIQueryMutation = gql `
    mutation RerunAIQuery($aiQueryRequestId: String!) {
        ai {
            rerunAiSqlQuery(aiQueryRequestId: $aiQueryRequestId) {
                aiQueryRequestId
                rows
            }
        }
    }
`;
